import { QrCodeScannerOutlined as QrCodeScannerOutlinedIcon } from '@mui/icons-material';
import { SxProps, Tooltip } from '@mui/material';
import { MouseEventHandler } from 'react';

export type QrCodeIconProps = {
  onClick: MouseEventHandler<SVGSVGElement>;
  sx?: SxProps;
  title: string;
  disabled?: boolean;
};

export const QrCodeIcon: React.FC<QrCodeIconProps> = ({
  onClick,
  sx,
  title,
  disabled,
}) => (
  <Tooltip title={title}>
    <QrCodeScannerOutlinedIcon
      fontSize="small"
      color={disabled ? 'disabled' : 'primary'}
      className={disabled ? 'tw-cursor-default' : 'tw-cursor-pointer'}
      sx={sx}
      onClick={disabled ? undefined : onClick}
    />
  </Tooltip>
);
